import type { ConversionValidationProjectionSummary } from "../../store/uploadStore";
import { apiCall } from "./base";

export interface ConversionReportResponse extends ConversionValidationProjectionSummary {
  source_conversion_job_id: string;
  failure: {
    category: "input" | "conversion" | "load";
    stopped_stage: string;
    code: string;
    message_key: string;
  } | null;
  log_merge_status: "converter_completed" | "loader_merged" | "failed";
  projected_at: string | null;
}

export const getConversionReport = async (
  userToken: string,
  jobId: string,
): Promise<ConversionReportResponse> =>
  (await apiCall(`/conversion/jobs/${encodeURIComponent(jobId)}/report`, {
    method: "GET",
    headers: { Authorization: `Bearer ${userToken}` },
  })) as ConversionReportResponse;
